module.exports = __webpack_public_path__ + "img/back.df6df620.svg";